import { Component, ContentChild, HostBinding, Input, Renderer2 } from '@angular/core';
import {
  TextareaProps,
  textareaStyles,
  fieldAppendStyles,
  fieldContainerStyles,
  fieldIconsStyles,
} from '@kite_aerolab/shared/components';
import { TextareaDirective } from './textarea.directive';

@Component({
  selector: 'kite-textarea-group',
  templateUrl: './textarea.component.html',
})
export class TextareaComponent {
  isFocused = false;

  /**
   *
   * Obtener los estados del textarea
   *
   * */
  @ContentChild(TextareaDirective, { static: false }) formControl: TextareaDirective;

  @HostBinding() get value() {
    return this.formControl ? this.formControl.value : '';
  }

  @HostBinding() get focus() {
    return this.formControl ? this.formControl.focus : false;
  }

  @HostBinding() get invalid() {
    return this.formControl ? this.formControl.isInvalid() : false;
  }

  @HostBinding('class.disabled') get disabled() {
    return this.formControl ? this.formControl.isDisabled() : false;
  }

  @HostBinding('class.disabled') get id() {
    return this.formControl ? this.formControl.getID() : '';
  }

  // eslint-disable-next-line no-useless-constructor
  constructor(private renderer: Renderer2) {}

  ngAfterViewInit() {
    if (this.formControl) {
      if (this.isInvalid) {
        this.renderer.setAttribute(this.formControl.el.nativeElement, 'aria-invalid', String(this.isInvalid));
      }
      if (this.isValid) {
        this.renderer.setAttribute(this.formControl.el.nativeElement, 'aria-valid', String(this.isValid));
      }
      if (this.error || this.label) {
        this.renderer.setAttribute(
          this.formControl.el.nativeElement,
          'aria-describedby',
          String(!this.isInvalid ? this.id + '-helptext' : this.id + '-feedback')
        );
      }
    } else {
      throw 'the kite-textarea-group component should include an textarea element with the kiteTextarea directive (for example: <input kiteInput type="text"/>). For more information you can view the documentation at https://paper.dropbox.com/doc/In-progress-Kite-UI-Documentation-for-users-6QOP7bqjW9MHEFtDcKgT7';
    }
  }

  /**
   * Label del campo
   */
  @Input() label: string;
  /**
   * Mensaje de ayuda
   */
  @Input() helper: string;
  /**
   * Mensaje de error
   */
  @Input() error: string;
  /**
   * CSS props del input
   */
  @Input() css: TextareaProps['css'];
  /**
   * Estado invalido
   */
  @Input() isInvalid: boolean;
  /**
   * Estado valido
   */
  @Input() isValid: boolean;
  /**
   * Agrega la opción de limpiar el campo
   */
  @Input() isClearable = true;

  /**
   * Clear del input
   */
  clearText() {
    this.formControl.clear();
  }

  focusAppend() {
    this.isFocused = true;
  }

  focusOutAppend() {
    this.isFocused = false;
  }

  /**
   * Estilos del textarea
   */
  public get textareaStyles(): string[] {
    return [
      textareaStyles({
        css: this.css,
        isInvalid: this.isInvalid,
        isValid: this.isValid,
        isDisabled: this.disabled,
      }).className,
    ];
  }

  /**
   * Estilos del contenedor
   */
  public get textareaContainerStyles(): string[] {
    return [fieldContainerStyles().className];
  }

  /**
   * Estilos del append
   */
  public get textareaAppendStyles(): string[] {
    return [fieldAppendStyles().className];
  }

  /**
   * Estilos de los íconos
   */
  public get textareaIconsStyles(): string[] {
    return [fieldIconsStyles().className];
  }
}
